import { DOCUMENT_VIEW_REQUEST, DOCUMENT_VIEW_SUCCESS, DOCUMENT_VIEW_FAILURE } from '../actions/view';

const initialState = {
    state: 'idle'
};

export default function view(state = initialState, action) {
    switch (action.type) {
        case DOCUMENT_VIEW_REQUEST:
            return {
                ...state,
                state: 'loading'
            };
        case DOCUMENT_VIEW_SUCCESS:
            return {
                ...state,
                ...action.payload,
                state: 'success'
            };
        case DOCUMENT_VIEW_FAILURE:
            return {
                ...state,
                state: 'failure'
            };
        default:
            return state;
    }
}
